/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_NameInputs */

const en_editor_ingredient_name = /** @type {(inputs: Editor_Ingredient_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredient`)
};

const de_editor_ingredient_name = /** @type {(inputs: Editor_Ingredient_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutat`)
};

/**
* | output |
* | --- |
* | "Ingredient" |
*
* @param {Editor_Ingredient_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_name = /** @type {((inputs?: Editor_Ingredient_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_name(inputs)
	return en_editor_ingredient_name(inputs)
});